import React, { Component } from "react";
import CustomLocationInput from "./customlocationinput";
import SongList from "./songlist";
import ClipLoader from "react-spinners/ClipLoader";
import { Grid } from "@mui/material";
import SelectGenre from "./selectgenre";
import SecondGenre from "./secondgenre";
import { connect } from "react-redux";
import {
  loadBandInfo,
  editBandName,
  editBandDesc,
  editBandGenre1,
  saveBandBegin,
} from "../actions/editbandactions";
import BandPicture from "./BandPicture";
import { confirmAlert } from "react-confirm-alert";
import { logoutBegin } from "../actions/logoutactions";
import { reportError } from "../actions/erroractions";
import { moveToOptionsPage } from "../actions/routeactions";
import { formatReviewStatus } from "../utils/Utils";
import { GENRES } from "../data/text";

class EditBand extends Component {
  state = {
    loading: false,
    name: "",
    desc: "",
    error_message: "",
    location: "",
    genres: GENRES,
    genre: "rock",
    is_second_genre: false,
    second_genre: "rock",
    fileUploadName: "Choose Image",
    bandpicture: null,
  };

  constructor(props) {
    super(props);

    this.updateName = this.updateName.bind(this);
    this.updateDesc = this.updateDesc.bind(this);
    this.saveBand = this.saveBand.bind(this);
    this.renderLoading = this.renderLoading.bind(this);
    this.renderSelectOptions = this.renderSelectOptions.bind(this);
    this.logout = this.logout.bind(this);
    this.setGenre = this.setGenre.bind(this);
    this.addAsterix = this.addAsterix.bind(this);
    this.toOptionsPage = this.toOptionsPage.bind(this);
    this.renderRejected = this.renderRejected.bind(this);
    this.isUnSaved = this.isUnSaved.bind(this);
  }

  componentDidMount() {
    const { dispatch, doLoad } = this.props;

    if (doLoad) {
      dispatch(loadBandInfo());
    }
  }

  componentDidUpdate() {

    if (this.isUnSaved()) {
      window.onbeforeunload = null;
    } else {
      window.onbeforeunload = () => true;
    }
  }

  isUnSaved() {
    const { unsaved, songs } = this.props;
    return unsaved.size === 0 &&
      Object.values(songs).filter((song) => !song.saved).length === 0
  }

  

  logout() {
    const { dispatch } = this.props;

    if (!this.isUnSaved()) {
      return confirmAlert({
            customUI: ({ onClose }) => {
              return (
                <div className="form" style={{ left: "50%" }}>
                  <Grid
                    container
                    direction="column"
                    justifyContent="center"
                    alignContent="center"
                  >
                    <Grid item xs={12}>
                      <p>There is unsaved data, are you sure you want to log out?</p>
                    </Grid>
                    <Grid container direction="row" justify="center">
                      <Grid item xs={4} />
                      <Grid item xs={2}>
                        <button
                          className="bbe-button"
                          onClick={() => {
                            onClose();
                            dispatch(logoutBegin());
                          }}
                        >
                          Yes
                        </button>
                      </Grid>
                      <Grid item xs={2}>
                        <button className="bbe-button" onClick={onClose}>
                          No
                        </button>
                      </Grid>
                      <Grid item xs={4} />
                    </Grid>
                  </Grid>
                </div>
              );
            },
          });
    } else {
      dispatch(logoutBegin());
    }
  }

  updateName(e) {
    const { dispatch } = this.props;
    dispatch(editBandName(e.target.value));
  }

  updateDesc(e) {
    const { dispatch } = this.props;
    dispatch(editBandDesc(e.target.value));
  }

  saveBand() {
    const { dispatch, name, desc, location } = this.props;
    const msg = this.validation(name, desc, location);

    if (msg !== "Fine") {
      dispatch(reportError(msg));
      return;
    } else {
      dispatch(saveBandBegin());
    }
  }

  validation(name, desc, location, band_loaded) {
    if (name == null || name.length === 0) {
      return "Band name can't be empty";
    } else if (location == null || location.length === 0) {
      return "Location needs to be selected";
    }

    return "Fine";
  }

  renderSelectOptions(exclude) {
    const { genres } = this.state;

    return genres.filter((e) => e !== exclude).map((e) => <option>{e}</option>);
  }

  setGenre(genre) {
    const { dispatch } = this.props;
    dispatch(editBandGenre1(genre));
  }

  renderLoading() {
    const { loading } = this.props;
    return (
      <div className="loading_div">
        <div className="loading_spinner">
          <ClipLoader
            color="#FFFFFF"
            sizeUnit={"%"}
            size={100}
            loading={loading}
          />
        </div>
      </div>
    );
  }

  addAsterix(fieldName) {
    const { unsaved } = this.props;
    return unsaved.has(fieldName) ? "*" : "";
  }

  toOptionsPage() {
    const { dispatch } = this.props;
    dispatch(moveToOptionsPage());
  }

  renderRejected(reason) {
    return (
      <React.Fragment>
        {reason != null ? <Grid item xs={12}><p>Rejected because "{reason}"</p></Grid> : <React.Fragment/>}
        <Grid item xs={12}><p>Please upload a new band picture</p></Grid>
      </React.Fragment>
    )
  }

  render() {
    const {
      loading,
      band_loaded,
      name,
      desc,
      genre1,
      bandNameError,
      reviewState,
      rejectionReason,
      unsaved,
    } = this.props;

    return (
      <div>
        <Grid container alignItems="center" justifyContent="center" spacing={10}>
          <div className="form edit_band_form" id="container">
            <Grid item xs={12}>
              <Grid container direction="row">
                <Grid item xs={2} />
                <Grid item xs={7}>
                  <h1>Band Details</h1>
                </Grid>
                <Grid item xs={1}>
                  <img
                    className="icon_button"
                    src="https://img.icons8.com/nolan/64/gear.png"
                    alt="Options"
                    title="Options"
                    onClick={this.toOptionsPage}
                  />
                </Grid>
                <Grid item xs={1} marginLeft={2}> 
                  <img
                    src="https://img.icons8.com/nolan/64/exit.png"
                    className="icon_button"
                    alt="logout"
                    title="Logout"
                    onClick={this.logout}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <label className="label">{`Band Name ${this.addAsterix(
                "BAND_NAME"
              )}`}</label>
            </Grid>
            <Grid item xs={12}>
              <input
                type="text"
                className={
                  (bandNameError ? "errorTextbox" : "textbox") + " stretchbox"
                }
                placeholder="Type Band Name"
                value={name}
                onChange={this.updateName}
              />
            </Grid>
            <Grid item xs={12}>
              <br />
            </Grid>
            <Grid item xs={12}>
              <label className="descLabel">{`Band Description ${this.addAsterix(
                "BAND_DESC"
              )}`}</label>
            </Grid>
            <Grid item xs={12}>
              <textarea
                className="textbox stretchbox"
                placeholder="Type Band Description"
                value={desc}
                onChange={this.updateDesc}
              ></textarea>
            </Grid>
            <Grid item xs={12}>
              <br />
            </Grid>
            <Grid item xs={12}>
              <label className="label">{`Location  ${this.addAsterix(
                "LOCATION"
              )}`}</label>
            </Grid>
            <Grid item xs={12}>
              <CustomLocationInput />
            </Grid>
            <Grid item xs={12}>
              <br />
            </Grid>
            <Grid item xs={12}>
              <label className="label">{`Genre 1 ${this.addAsterix(
                "GENRE_1"
              )}`}</label>
            </Grid>
            <Grid item xs={12}>
              <SelectGenre
                setGenre={this.setGenre}
                genre={genre1}
              />
            </Grid>
            <Grid item xs={12}>
              <br />
            </Grid>
            <SecondGenre
              unsavedIsSecondGenre={unsaved.has("IS_SECOND_GENRE")}
              unsavedSecondGenre={unsaved.has("GENRE_2")}
            />
            <Grid item xs={12}>
              <br />
            </Grid>
            <Grid item xs={12}>
              <label className="label">{`Band Picture ${this.addAsterix(
                "BAND_PICTURE"
              )}`}</label>
            </Grid>
            {
              reviewState === "REJECTED" ? this.renderRejected(rejectionReason) : <React.Fragment/>
            }
            <Grid item xs={12}>
              <BandPicture />
            </Grid>
            <div style={{ padding: 20 }}>
              <Grid item xs={12}>
                  <label>{formatReviewStatus(reviewState)}</label>
              </Grid>
            </div>
            <Grid item xs={12}>
              <img
                className="icon_button extra_padding"
                src="https://img.icons8.com/nolan/64/save.png"
                onClick={this.saveBand}
                alt="Save Band Information"
                title="Save Band Information"
              />
            </Grid>
            <Grid item xs={12}>
              <p className="validation_msg">For any support contact barbandexplorer@gmail.com</p>
            </Grid>
            
            <Grid item xs={12}>
              <h2>Songs</h2>
            </Grid>
            <Grid item xs={12}>
              {band_loaded ? <SongList ref={this.songList} /> : <p>Band needs to be saved before songs can be uploaded</p>}
            </Grid>
          </div>
        </Grid>
        {loading ? this.renderLoading() : <React.Fragment />}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.editband.loading,
  name: state.editband.name,
  desc: state.editband.desc,
  genre1: state.editband.genre1,
  genre2: state.editband.genre2,
  location: state.editband.location,
  is_second_genre: state.editband.is_second_genre,
  unsaved: state.editband.unsaved,
  bandNameError: state.error.bandNameError,
  band_loaded: state.editband.exists,
  songs: state.songs.songs,
  reviewState: state.editband.reviewState,
  rejectionReason: state.editband.rejectionReason
});

export default connect(mapStateToProps)(EditBand);
